module.exports = __webpack_public_path__ + "img/corporal_thumb.73eb26b7.jpg";